(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-mt-delay') || 0;
            setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.mt-faq__pregunta');
      var panel = item.querySelector('.mt-faq__respuesta');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-abierto');
        items.forEach(function (other) {
          other.classList.remove('mt-abierto');
          var p = other.querySelector('.mt-faq__respuesta');
          if (p) p.style.maxHeight = null;
        });
        if (!abierto) {
          item.classList.add('mt-abierto');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function initCifras() {
    var grids = document.querySelectorAll('.mt-cifras__grid');
    if (!grids.length) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var nums = entry.target.querySelectorAll('.mt-cifra__numero');
          nums.forEach(function (el) {
            var target = parseFloat(el.getAttribute('data-target') || '0');
            var suffix = el.getAttribute('data-suffix') || '';
            var duration = 1400;
            var start = null;
            function step(ts) {
              if (!start) start = ts;
              var progress = Math.min((ts - start) / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              var value = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
              el.textContent = value + suffix;
              if (progress < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          });
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );
    grids.forEach(function (g) { obs.observe(g); });
  }

  function initComparador() {
    var marcos = document.querySelectorAll('[data-mt-comparador]');
    if (!marcos.length) return;
    marcos.forEach(function (marco) {
      var despues = marco.querySelector('[data-mt-comparador-despues]');
      var asa = marco.querySelector('[data-mt-comparador-asa]');
      var activo = false;

      function actualizar(clientX) {
        var rect = marco.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        despues.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        asa.style.left = pct + '%';
      }

      marco.addEventListener('pointerdown', function (e) {
        activo = true;
        marco.setPointerCapture(e.pointerId);
        actualizar(e.clientX);
      });
      marco.addEventListener('pointermove', function (e) {
        if (!activo) return;
        actualizar(e.clientX);
      });
      marco.addEventListener('pointerup', function () { activo = false; });
      marco.addEventListener('pointerleave', function () { activo = false; });
    });
  }

  function initComprar() {
    var roots = document.querySelectorAll('[data-mt-comprar]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var variantId = root.getAttribute('data-mt-variant-id');
      var tiers = root.querySelectorAll('[data-mt-tier]');
      var boton = root.querySelector('[data-mt-comprar-boton]');
      var notaEnvio = root.querySelector('[data-mt-nota-envio]');

      function seleccionar(tier) {
        tiers.forEach(function (t) { t.classList.remove('mt-activa'); });
        tier.classList.add('mt-activa');
        var qty = tier.getAttribute('data-mt-tier');
        if (boton) boton.setAttribute('data-mt-qty', qty);
        if (notaEnvio) {
          var envio = tier.getAttribute('data-mt-envio-gratis');
          notaEnvio.style.visibility = envio === 'true' ? 'visible' : 'hidden';
        }
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () { seleccionar(tier); });
      });

      if (boton) {
        boton.addEventListener('click', function () {
          var qty = parseInt(boton.getAttribute('data-mt-qty') || '1', 10);
          var textoOriginal = boton.textContent;
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-mt-texto-cargando') || '...';
          fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
          })
            .then(function (res) { res.json(); return res; })
            .then(function () {
              boton.textContent = boton.getAttribute('data-mt-texto-hecho') || 'Added!';
              window.location.href = '/cart';
            })
            .catch(function () {
              boton.textContent = textoOriginal;
              boton.disabled = false;
            });
        });
      }
    });
  }

  function initProducto() {
    var root = document.querySelector('[data-mt-producto]');
    if (!root) return;

    var variantsData = [];
    try {
      var script = root.querySelector('[data-mt-variantes]');
      if (script) variantsData = JSON.parse(script.textContent);
    } catch (e) { variantsData = []; }

    var form = root.querySelector('[data-mt-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var precioActual = root.querySelector('[data-mt-precio-actual]');
    var precioAnterior = root.querySelector('[data-mt-precio-anterior]');
    var botonComprar = root.querySelector('[data-mt-boton-comprar]');
    var pildoraGrupos = root.querySelectorAll('[data-mt-opcion]');

    function formatoMoneda(cents) {
      if (window.Shopify && Shopify.formatMoney && window.mtMoneyFormat) {
        return Shopify.formatMoney(cents, window.mtMoneyFormat);
      }
      return (cents / 100).toFixed(2);
    }

    function seleccionActual() {
      var seleccion = [];
      pildoraGrupos.forEach(function (grupo) {
        var activa = grupo.querySelector('.mt-activa');
        seleccion.push(activa ? activa.getAttribute('data-mt-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = seleccionActual();
      return variantsData.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
    }

    function actualizar() {
      var variante = variantsData.length ? encontrarVariante() : null;
      if (!variante && variantsData.length) return;

      if (variante) {
        if (idInput) idInput.value = variante.id;
        if (precioActual) precioActual.textContent = formatoMoneda(variante.price);
        if (precioAnterior) {
          if (variante.compare_at_price && variante.compare_at_price > variante.price) {
            precioAnterior.textContent = formatoMoneda(variante.compare_at_price);
            precioAnterior.style.display = '';
          } else {
            precioAnterior.style.display = 'none';
          }
        }
        if (botonComprar) {
          botonComprar.disabled = !variante.available;
          botonComprar.textContent = variante.available
            ? botonComprar.getAttribute('data-mt-texto-disponible')
            : botonComprar.getAttribute('data-mt-texto-agotado');
        }
      }

      pildoraGrupos.forEach(function (grupo) {
        var pildoras = grupo.querySelectorAll('[data-mt-valor]');
        pildoras.forEach(function (p) {
          if (!variantsData.length) return;
          var valor = p.getAttribute('data-mt-valor');
          var seleccion = seleccionActual();
          var idx = Array.prototype.indexOf.call(pildoraGrupos, grupo);
          var pruebaSeleccion = seleccion.slice();
          pruebaSeleccion[idx] = valor;
          var existe = variantsData.some(function (v) {
            return v.options.every(function (opt, i) {
              return pruebaSeleccion[i] === null || opt === pruebaSeleccion[i];
            });
          });
          p.disabled = !existe;
        });
      });
    }

    pildoraGrupos.forEach(function (grupo) {
      grupo.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mt-valor]');
        if (!btn || btn.disabled) return;
        grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
        actualizar();
      });
    });

    var galeria = root.querySelector('[data-mt-galeria-principal]');
    root.querySelectorAll('[data-mt-miniatura]').forEach(function (min) {
      min.addEventListener('click', function () {
        root.querySelectorAll('[data-mt-miniatura]').forEach(function (m) { m.classList.remove('mt-activa'); });
        min.classList.add('mt-activa');
        var full = min.getAttribute('data-mt-full');
        if (galeria && full) {
          var img = galeria.querySelector('img');
          if (img) img.src = full;
        }
      });
    });

    var cantidadInput = root.querySelector('[data-mt-cantidad]');
    root.querySelectorAll('[data-mt-cantidad-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!cantidadInput) return;
        var delta = btn.getAttribute('data-mt-cantidad-btn') === 'mas' ? 1 : -1;
        var val = Math.max(1, (parseInt(cantidadInput.value, 10) || 1) + delta);
        cantidadInput.value = val;
      });
    });

    actualizar();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFaq();
    initCifras();
    initComparador();
    initComprar();
    initProducto();
  });
})();
